import { render, staticRenderFns } from "./SliderAlimentation.vue?vue&type=template&id=995e3cce&scoped=true&"
import script from "./SliderAlimentation.vue?vue&type=script&lang=ts&"
export * from "./SliderAlimentation.vue?vue&type=script&lang=ts&"
import style0 from "./SliderAlimentation.vue?vue&type=style&index=0&id=995e3cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995e3cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VIcon,VImg,VRow,VSlideGroup,VSlideItem})
